/* eslint-disable no-new-wrappers */
import React, { Component, Fragment } from 'react';
import {
	Menu,
	Icon,
	message,
	Divider,
	Avatar,
	Row,
	Col,
	Badge,
	Tooltip,
	Popover,
	Drawer,
	notification,
	Modal,
	Switch,
	Button,
} from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from 'actions';
import * as types from 'actions/ActionTypes';
import * as services from 'services';
import { ReactComponent as Logo } from 'components/logos/logo.svg';
import SubMenu from 'antd/lib/menu/SubMenu';
import Login from 'components/login';
import moment from 'moment';
import ReactGA from 'react-ga';

const LogoIcon = props => <Icon component={Logo} {...props} />;

const mapStateToProps = state => ({
	title: state.info.title,
	text: state.info.text,
	lqscore: state.info.lqscore,
	decos: state.spell.decos,
	synos: state.syno.synos,
	lqInfos: state.info.lqInfos,
	authenticated: state.auth.authenticated,
	user: state.auth.user,
});

const mapDispatchToProps = dispatch => ({
	onShowModalReport: visiable => dispatch(actions.onShowModalReport(visiable)),
	validate: user => dispatch(actions.validate(user)),
	logout: () => dispatch(actions.logout()),
	onCheckLqByPara: checked => dispatch(actions.onCheckLqByPara(checked)),
	onCheckSpell: checked => dispatch(actions.onCheckSpell(checked)),
	onCheckSyno: checked => dispatch(actions.onCheckSyno(checked)),
	onCheckDialect: checked => dispatch(actions.onCheckDialect(checked)),
});

const info2 = () => {
	message.info('단어를 더블 클릭하시면 단어의 뜻풀이 정보를 확인하실 수 있습니다.');
};

const LoginMenu = props => (
	<div style={{ padding: 0, margin: 0 }}>
		<Row>
			<Col>
				<a href={types.LOCAL_URL + '/views/mypage/archive?tabs=grammar1'}>마이페이지</a>
			</Col>
		</Row>
		<Row>
			<Col>
				<Divider />
			</Col>
		</Row>
		<Row>
			<Col>
				<span onClick={props.onLogout} style={{ cursor: 'pointer' }}>
					로그아웃
				</span>
			</Col>
		</Row>
	</div>
);

const LoginAvata = props => {
	if (props.login)
		return (
			<Popover placement="rightTop" content={<LoginMenu {...props} />} trigger="click">
				<div style={{ width: '50px', textAlign: 'center' }}>
					<span>
						<Badge dot color="#87d068">
							<Avatar
								style={{ backgroundColor: '#1890ff', verticalAlign: 'middle', cursor: 'pointer' }}
								size="large"
							>
								{props.userName}
							</Avatar>
						</Badge>
					</span>
				</div>
			</Popover>
		);
	else
		return (
			<span>
				<div style={{ width: '50px', textAlign: 'center', cursor: 'pointer' }} onClick={props.onLogin}>
					<Avatar icon="user" />
				</div>
			</span>
		);
};

let timerId = null;

class LeftMenu extends Component {
	state = {
		show: false,
		login: false,
		visible: false,
		logOff: false,
		checkSpell: true,
		checkSyno: true,
		checkDialect: true,
		checkAutoSave: false,
		prevText: '',
		modalVisible: false,
		url: '',
		name: '',
	};

	fetchSaveContents = async datas => {
		const post = await services.postApi(this, '/api/archive/sentence/create', datas);
		if (post && post.status === 200) {
			message.info('저장 되었습니다.');
			return post.data != null ? post.data.board : 0;
		}
		message.error('서버 오류로 저장되지 못했습니다. 잠시 후 다시 저장해 주세요.');
		return 0;
	};

	constructor(props) {
		super(props);
		const USER = JSON.parse(window.localStorage.getItem('user'));

		let infoModal = false;
		if (USER != null) {
			ReactGA.set({ userId: USER.id });
			this.props.validate(USER);
		} else {
			infoModal = true;
		}

		window.sessionStorage.setItem('board', this.props.match.params.board);

		const date = moment();
		const remain = moment('2019-10-07').diff(date, 'days');

		this.state = {
			...this.state,
			board: this.props.match.params.board,
			remain,
			expireDate: moment('2019-10-07'),
			infoModal,
		};
	}

	componentDidMount() {
		let checkLqByPara = true,
			checkSpell = true,
			checkSyno = true,
			checkDialect = true,
			checkAutoSave = false;

		if (window.localStorage.getItem('checkLqByPara') != null) {
			checkLqByPara = JSON.parse(window.localStorage.getItem('checkLqByPara'));
		}
		if (window.localStorage.getItem('checkSpell') != null) {
			checkSpell = JSON.parse(window.localStorage.getItem('checkSpell'));
		}
		if (window.localStorage.getItem('checkSyno') != null) {
			checkSyno = JSON.parse(window.localStorage.getItem('checkSyno'));
		}
		if (window.localStorage.getItem('checkDialect') != null) {
			checkDialect = JSON.parse(window.localStorage.getItem('checkDialect'));
		}

		this.props.onCheckLqByPara(checkLqByPara);
		this.props.onCheckSpell(checkSpell);
		this.props.onCheckSyno(checkSyno);
		this.props.onCheckDialect(checkDialect);

		this.setState({
			user: this.props.user,
			login: this.props.authenticated,
			title: this.props.title,
			text: this.props.text,
			lqscore: this.props.lqscore,
			decos: this.props.decos,
			synos: this.props.synos,
			checkLqByPara,
			checkSpell,
			checkSyno,
			checkDialect,
			checkAutoSave,
		});
	}

	componentWillReceiveProps(nextProps) {
		let checkAutoSave = false;
		if (window.localStorage.getItem('checkAutoSave') != null && nextProps.authenticated) {
			checkAutoSave = JSON.parse(window.localStorage.getItem('checkAutoSave'));
		}
		this.setState({
			title: nextProps.title,
			text: nextProps.text,
			lqscore: nextProps.lqscore,
			decos: nextProps.decos,
			synos: nextProps.synos,
			authenticated: nextProps.authenticated,
			user: nextProps.user,
			login: nextProps.authenticated,
			checkAutoSave,
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.authenticated !== prevState.authenticated) {
			if (!this.state.logOff) {
				this.setState({
					login: this.state.authenticated,
					userName: this.state.user && this.state.user.userName,
				});
			} else {
				this.setState({
					login: this.state.authenticated,
				});
			}
			if (this.state.authenticated) {
				const USER = JSON.parse(window.localStorage.getItem('user'));

				if (USER != null) {
					this.props.validate(USER);
					ReactGA.set({ userId: USER.id }, ['USER']);
				}
				this.setState({ visible: false });
			}
		}
		if (this.state.checkAutoSave !== prevState.checkAutoSave) {
			if (this.state.checkAutoSave) {
				timerId = setInterval(this.autoSave, 60000 * 1);
			} else {
				if (timerId != null) {
					clearInterval(timerId);
				}
			}
		}
	}

	showPaymentModal = (name, url) => {
		this.setState({
			name,
			url,
			modalVisible: true,
		});
	};

	handleOk = e => {
		window.location.href = '/views/mypage/payment/step1';
		this.setState({
			modalVisible: false,
		});
	};

	handleCancel = e => {
		this.setState({
			modalVisible: false,
		});
	};

	infoModalHandleCancel = e => {
		if (this.props.match.params.board.indexOf('sample') < 0) {
			info2();
		}
		this.setState({
			infoModal: false,
		});
	};

	infoModalClick = e => {
		e.preventDefault();
		this.setState({
			infoModal: false,
		});
		this.showDrawer(1);
	};

	showDrawer = value => {
		notification.destroy();
		this.setState({
			visible: true,
			value,
		});
	};

	onClose = () => {
		this.setState({
			visible: false,
		});
	};

	onLogin = e => {
		e.preventDefault();
		this.showDrawer(0);
	};

	goToUrl = url => {
		window.location.href = url;
	};

	save = async () => {
		if (this.props.match.params.board.indexOf('sample') < 0) {
			if (this.state.title == null || (this.state.title != null && this.state.title.trim() === '')) {
				message.error('글 제목을 입력해 주세요.');
				return;
			}

			if (this.state.text != null && this.state.text.trim() !== '') {
				const USER = JSON.parse(window.sessionStorage.getItem('user'));

				//새로 고침시 로그인 유지
				if (USER != null) {
					const result = await this.fetchSaveContents({
						board: this.state.board,
						user: USER.id,
						title: this.state.title,
						text: this.state.text,
						lqscore: this.state.lqscore != null ? this.state.lqscore : 0,
						count_spell: this.state.decos.length,
						count_synos: this.state.synos.length,
					});

					window.sessionStorage.setItem('board', result);

					this.setState({ board: result });
				} else {
					message.error('로그인 후 저장이 가능합니다.');
				}
			} else {
				message.error('작성된 글이 없습니다. 글을 작성 후 저장 할 수 있습니다.');
			}
		} else {
			message.error('샘플문서는 저장하실 수 없습니다.');
		}
	};

	autoSave = async () => {
		if (this.props.match.params.board.indexOf('sample') < 0) {
			let title = '';
			if (this.state.title == null || (this.state.title != null && this.state.title.trim() === '')) {
				//message.error('글 제목을 입력해 주세요.');
				title = '제목없음';
				//return;
			}

			if (this.state.text != null && this.state.text.trim() !== '') {
				const USER = JSON.parse(window.sessionStorage.getItem('user'));

				//새로 고침시 로그인 유지
				if (USER != null) {
					if (this.state.text !== this.state.prevText) {
						const result = await this.fetchSaveContents({
							board: this.state.board,
							user: USER.id,
							title: title,
							text: this.state.text,
							lqscore: this.state.lqscore != null ? this.state.lqscore : 0,
							count_spell: this.state.decos.length,
							count_synos: this.state.synos.length,
						});
						this.setState({ board: result, prevText: this.state.text });
					}
				} else {
					message.error('로그인 후 저장이 가능합니다.');
				}
			} else {
				//message.error('작성된 글이 없습니다. 글을 작성 후 저장 할 수 있습니다.');
			}
		} else {
			//message.error('샘플문서는 저장하실 수 없습니다.');
		}
	};

	downLoad = () => {
		const element = document.createElement('a');
		const title = this.state.title != null ? this.state.title : '';
		const text = this.state.text != null ? this.state.text : '';

		const file = new Blob([title + '\n\n', text], { type: 'text/plain' });
		element.href = URL.createObjectURL(file);
		element.download = 'Documents.txt';
		document.body.appendChild(element); // Required for this to work in FireFox
		element.click();
	};

	showReport(visiable) {
		const user = this.props.user;
		if (this.props.match.params.board.indexOf('sample') < 0) {
			//const USER = JSON.parse(window.sessionStorage.getItem('user'));

			//새로 고침시 로그인 유지
			if (user != null) {
				if (user.status === 'valid' && user.item === 'premium') {
					if (this.state.text != null && this.state.text.trim() !== '') {
						this.props.onShowModalReport(visiable);
					} else {
						message.error('작성된 글이 없습니다. 보고서는 글을 작성 후 생성할 수 있습니다.');
					}
				} else {
					this.showPaymentModal('보고서', 'ani_img03_1.png');
				}
			} else {
				this.showPaymentModal('보고서', 'ani_img03_1.png');
			}
		} else {
			if (this.state.text != null && this.state.text.trim() !== '') {
				this.props.onShowModalReport(visiable);
			} else {
				message.error('작성된 글이 없습니다. 보고서는 글을 작성 후 생성할 수 있습니다.');
			}
		}
	}

	onLogout = e => {
		Modal.confirm({
			title: '확인',
			content: (
				<p>
					로그아웃 하시겠습니까? <br />
					저장 하지 않은 문서는 복구 되지 않습니다.
				</p>
			),
			okText: '예',
			cancelText: '아니오',
			onOk: async () => {
				this.setState({
					logOff: true,
				});
				this.props.logout();
			},
		});
	};

	onNewDocuments = () => {
		Modal.confirm({
			title: '확인',
			content: (
				<p>
					새로운 문서를 작성하시겠습니까? <br />
					저장 하지 않은 문서는 복구 되지 않습니다.
				</p>
			),
			okText: '예',
			cancelText: '아니오',
			onOk: () => {
				this.goToUrl('/sentence/0');
			},
		});
	};

	render() {
		return (
			<Fragment>
				<div style={{ marginTop: 0, padding: 0 }}>
					<Row type="flex" justify="center" style={{ background: '#596674', padding: 10 }}>
						<Col>
							<Tooltip placement="right" title="홈으로">
								<LogoIcon
									style={{ fontSize: '32px' }}
									onClick={() => this.goToUrl('/views/sentence')}
								/>
							</Tooltip>
						</Col>
					</Row>
					<Row
						type="flex"
						justify="center"
						style={{ background: '#8394a7', paddingTop: 10, paddingBottom: 10 }}
					>
						<Col>
							<LoginAvata
								login={this.state.login}
								onLogin={this.onLogin}
								userName={this.state.userName}
								onLogout={this.onLogout}
							/>
						</Col>
					</Row>
					<Menu mode="inline" style={{ background: '#596674', color: '#fff' }}>
						<Menu.Item key="3" onClick={this.onNewDocuments}>
							<Icon type="file-add" style={{ fontSize: '20px' }} theme="outlined" />
							<span>새로운 문서</span>
						</Menu.Item>
						<Menu.Item key="4" onClick={this.save}>
							<Icon type="save" style={{ fontSize: '20px' }} theme="outlined" />
							<span>저장</span>
						</Menu.Item>
						<Menu.Item key="5" onClick={() => this.showReport(true)}>
							<Icon type="bar-chart" style={{ fontSize: '20px' }} theme="outlined" />
							<span>보고서</span>
						</Menu.Item>
						<Menu.Item key="7" onClick={this.downLoad}>
							<Icon type="download" style={{ fontSize: '20px' }} theme="outlined" />
							<span>문서 다운로드</span>
						</Menu.Item>
						<SubMenu
							key="8"
							title={
								<span>
									<Icon type="setting" style={{ fontSize: '20px' }} theme="outlined" />
									<span>설정</span>
								</span>
							}
						>
							<Menu.Item key="0">
								<Row type="flex" justify="space-between">
									<Col>난이도</Col>
									<Col>
										<Switch
											size="small"
											checked={this.state.checkLqByPara}
											onClick={(checked, e) => {
												e.stopPropagation();
												this.setState({ checkLqByPara: checked });
												this.props.onCheckLqByPara(checked);

												window.localStorage.setItem('checkLqByPara', JSON.stringify(checked));
											}}
											checkedChildren="켬"
											unCheckedChildren="끔"
										/>
									</Col>
								</Row>
							</Menu.Item>
							<Menu.Item key="1">
								<Row type="flex" justify="space-between">
									<Col>맞춤법 검사</Col>
									<Col>
										<Switch
											size="small"
											checked={this.state.checkSpell}
											onClick={(checked, e) => {
												e.stopPropagation();
												this.setState({ checkSpell: checked });
												this.props.onCheckSpell(checked);

												window.localStorage.setItem('checkSpell', JSON.stringify(checked));
											}}
											checkedChildren="켬"
											unCheckedChildren="끔"
										/>
									</Col>
								</Row>
							</Menu.Item>
							<Menu.Item key="2">
								<Row type="flex" justify="space-between">
									<Col>유의어 추천</Col>
									<Col>
										<Switch
											size="small"
											checked={this.state.checkSyno}
											onClick={(checked, e) => {
												e.stopPropagation();
												this.setState({ checkSyno: checked });
												this.props.onCheckSyno(checked);
												window.localStorage.setItem('checkSyno', checked);
											}}
											checkedChildren="켬"
											unCheckedChildren="끔"
										/>
									</Col>
								</Row>
							</Menu.Item>
							<Menu.Item key="3">
								<Row type="flex" justify="space-between">
									<Col>방언 추천</Col>
									<Col>
										<Switch
											size="small"
											checked={this.state.checkDialect}
											onClick={(checked, e) => {
												e.stopPropagation();
												this.setState({ checkDialect: checked });
												this.props.onCheckDialect(checked);
												window.localStorage.setItem('checkDialect', checked);
											}}
											checkedChildren="켬"
											unCheckedChildren="끔"
										/>
									</Col>
								</Row>
							</Menu.Item>
							<Menu.Item key="4">
								<Row type="flex" justify="space-between">
									<Col>자동 저장(1분)</Col>
									<Col>
										<Switch
											size="small"
											checked={this.state.checkAutoSave}
											onClick={(checked, e) => {
												e.stopPropagation();
												if (this.state.authenticated) {
													this.setState({ checkAutoSave: checked });
													window.localStorage.setItem('checkAutoSave', checked);
												} else {
													message.error('로그인 후 이용 가능한 서비스입니다.');
												}
											}}
											checkedChildren="켬"
											unCheckedChildren="끔"
										/>
									</Col>
								</Row>
							</Menu.Item>
						</SubMenu>
					</Menu>
				</div>
				<Drawer
					width={500}
					closable={true}
					onClose={this.onClose}
					visible={this.state.visible}
					height="100%"
					zIndex={1009}
					style={{ padding: 0, margin: 0 }}
					bodyStyle={{ padding: 0, margin: 0, backgroundColor: '#152733', height: '100%' }}
				>
					<Login value={this.state.value} />
				</Drawer>
				<Modal
					title="문장검사 서비스입니다."
					visible={this.state.modalVisible}
					onOk={this.handleOk}
					onCancel={this.handleCancel}
					okText="예"
					cancelText="아니오"
					width={'70%'}
					centered
					bodyStyle={{ backgroundColor: '#4b4848', color: 'white' }}
				>
					<div>
						<p>선택하신 {this.state.name} 서비스는 문장검사 서비스입니다.</p>
						<p>문장검사 서비스 이용권을 결제하시겠습니까?</p>
						<div sytle={{ fontSize: 10, textAlign: 'center' }}>
							<img src={'/assets/imgs/sentence/' + this.state.url} alt={this.state.name} width={'100%'} />
						</div>
					</div>
				</Modal>
				{!this.props.user && this.state.remain > 0 && (
					<Modal
						visible={this.state.infoModal}
						onOk={this.infoModalHandleOk}
						onCancel={this.infoModalHandleCancel}
						footer={null}
						width={500}
						centered
						bodyStyle={{ backgroundColor: 'white', textAlign: 'center' }}
					>
						<div>
							<h3>
								지금 회원 가입하시고
								<br /> {this.state.expireDate.format('YYYY년 MM월 DD일')}까지 <br />
								모든 서비스를 무료로 이용하세요.
							</h3>
						</div>
						<div style={{ padding: 10 }}>
							<Button key="submit" type="primary" onClick={this.infoModalClick}>
								가입하기
							</Button>
						</div>
					</Modal>
				)}
			</Fragment>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LeftMenu));
